import React from 'react';
import { Button, Grid, Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import './style.css';
import { push } from 'connected-react-router';
import { load, logout } from '../../redux/modules/auth';
import IdleTimer from 'react-idle-timer';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: 1000 * 60 * 30,
            isTimedOut: false
        }
        this.idleTimer = null;
        this.onAction = this._onAction.bind(this);
        this.onActive = this._onActive.bind(this);
        this.onIdle = this._onIdle.bind(this);
    }
    componentWillMount() {
        const { dispatch } = this.props;
        dispatch(load())
    }

    handleDashboard = () => {
        const { dispatch } = this.props;
        dispatch(push('/account/dashboard'));
    }

    handleAddNewUser = () => {
        const { dispatch } = this.props;
        dispatch(push('/account/admin/users'));
    }

    handleSignIn = () => {
        window.location = '/';
    }

    handleSignOut = () => {
        const { dispatch } = this.props;
        dispatch(logout());
    }

    _onAction() {
        this.setState({ isTimedOut: false })
    }

    _onActive() {
        this.setState({ isTimedOut: false })
    }

    _onIdle() {
        const isTimedOut = this.state.isTimedOut
        if (isTimedOut) {
            const { dispatch } = this.props;
            dispatch(logout());
        } else {
            this.idleTimer.reset();
            this.setState({ isTimedOut: true })
        }
    }

    render() {
        const { user } = this.props;
        return (
            <Container fluid={true} className="mb20">
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={this.state.timeout} />
                <div className="well">
                    {user ?
                        <Grid columns='2'>
                            <Grid.Row>
                                <Grid.Column>
                                    <Button className="dashboardBtn" onClick={this.handleDashboard}>
                                        Dashboard
                                    </Button>
                                    {user && user.role === 1 &&
                                        <Button className="dashboardBtn" onClick={this.handleAddNewUser}>
                                            Add New User
                                        </Button>}
                                </Grid.Column>
                                <Grid.Column>
                                    <Button className="dashboardBtn signoutBtn" onClick={this.handleSignOut}>
                                        Sign Out
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        :
                        <Button className="dashboardBtn" onClick={(e) => this.handleSignIn(e)}>
                            Sign In
                        </Button>
                    }
                </div>
            </Container>
        )
    }
}

export default connect(state => ({
    user: state.get('auth').get('user'),
}))(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.js